import React from 'react';
import { Row, Col, Input, Typography } from 'antd';

const { TextArea } = Input;
const { Text } = Typography;

export function TextAreaCustom({
  title,
  changeText,
  blur,
  placeholder,
  lengthText = 0,
  defaultValue,
  fontSize,
  maxRows = 5,
  value,
  fullHeight = false,
  style,
  ...props
}) {
  const onChange = e => changeText(e.target.value);

  const fullHeightStyles = fullHeight
    ? {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }
    : {};

  const textAreaFullHeightStyles = fullHeight
    ? {
        height: '100%',
        resize: 'none',
      }
    : {};

  return (
    <Row
      style={{
        width: '100%',
        ...fullHeightStyles,
        ...style,
      }}
    >
      {title && (
        <Col
          md={24}
          lg={24}
          xs={24}
          style={{
            width: '100%',
          }}
        >
          <Text
            strong
            style={{
              fontSize: 14,
              color: '#707070',
            }}
          >
            {title}
          </Text>
        </Col>
      )}
      <Col
        md={24}
        lg={24}
        xs={24}
        style={{
          width: '100%',
          flex: fullHeight ? 1 : 'unset',
          minHeight: fullHeight ? 0 : 'unset',
        }}
      >
        <TextArea
          showCount={lengthText > 0 && lengthText !== Infinity}
          maxLength={lengthText || '2000'}
          color="#707070"
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: 2,
            border: '2px solid #EFEFEF',
            fontSize,
            ...textAreaFullHeightStyles,
          }}
          value={value}

          autoSize={fullHeight ? { minRows: 3 } : { minRows: 3, maxRows }}
          placeholder={placeholder || ''}
          onChange={onChange}
          defaultValue={defaultValue}
          {...props}
        />
      </Col>
    </Row>
  );
}
